import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuPlacement, SingleValue } from 'react-select';

import { LanguageOption, LanguageService } from '@umanforge/common';
import { Select } from '../inputs/select.component';

interface LanguageSelectorProps {
  menuPlacement: MenuPlacement;
  value?: LanguageOption;
  icon?: React.SVGProps<SVGSVGElement>;
  disabled?: boolean;
  onChange?: ( newValue: LanguageOption ) => void;
};

export const LanguageSelector = ( { menuPlacement, icon, value, onChange, disabled = false }: LanguageSelectorProps ) => {
  const { i18n } = useTranslation();

  const [ selectedLanguage, setSelectedLanguage ] = useState( value ?? LanguageService.getLanguages().find( lang => { return lang.value === i18n.language; } ) );

  const onChangeLang = ( newValue: SingleValue<LanguageOption> ) => {
    setSelectedLanguage( newValue ?? LanguageService.getLanguages().find( lang => { return lang.value === i18n.language; } ) );
    if ( onChange != null ) {
      onChange( newValue as LanguageOption );
    }
  };

  return (
    <div className="w-full">
      <Select
        required
        disabled={ disabled }
        value={ selectedLanguage }
        options={ LanguageService.getLanguages() }
        onChange={ onChangeLang }
        icon={ icon }
        menuPlacement={ menuPlacement }
        formatOptionLabel={ language => {
          return (
            <div className="flex gap-2">
              <div className="w-6 rounded-md">
                { language.flag }
              </div>
              <span className='text-sm font-medium'>{language.label}</span>
            </div>
          ); }
        }
      />
    </div>
  );
};